import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getGetUrlFile } from "../../../../services/File/File";
import type { ImageWithURL } from "../../../../types/generic.types";
import ProductCardImagesNavigator from "../ProductCard/ProductCardCarousel/ProductCardCarousel";
import "./SupplierCard.css";

interface IProps {
  supplier: any;
}

const SupplierCard = (props: IProps) => {
  const toast = useRef<Toast>(null);
  const { t } = useTranslation("common");
  const [logo, setLogo] = useState<ImageWithURL | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const classBody: HTMLCollection =
      document.getElementsByClassName("p-card-body");
    if (classBody && classBody.length > 0)
      for (let x = 0; x < classBody.length; x++)
        classBody[x].className = "p-card-body-custom";
      
    const image = props.supplier.logo;
    if (image && image.key) {
      getGetUrlFile(image.key)
        .then((res) => {
          setLogo({ filename: image.filename, key: image.key, url: res });
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [props.supplier.logo?.key]);

  if (loading) {
    return <ProgressSpinner />;
  }

  return (
    <>
      <Toast ref={toast} position="top-right"></Toast>
      <Card
        title={props.supplier.name}
        className="supplier-card-style"
        header={logo && logo.url ? <ProductCardImagesNavigator images={[logo]} /> : undefined}
      >
        <div className="display-flex flex-direction-column justify-content-center align-items-center">
          <div
            className="general-button"
            style={{ marginTop: "1rem" }}
            onClick={() =>
              window.open(
                `/#/producerProfile/${props.supplier?._id}`,
                "_self"
              )
            }
          >
            {t("common:goToSupplier")}
          </div>
        </div>
      </Card>
    </>
  );
};

export default SupplierCard;